<template>
    <div>
        <EditorBlock title="Editor" :block="block">
            <template #cardbody>
                <div class="row d-flex justify-content-center mt-2">
                    <TipTapMenu v-if="selectedEditor" :editor="selectedEditor" @editHtml="editHtml"></TipTapMenu>
                </div>
                <div class="pt-2 row">
                    <div :class="'col-'+col_1">
                        <div class="column-gap ml-2">
                            <b-input size="sm" class="column-input mb-2" type="number" min="1" max="11" v-model="col_1"/> / 12
                        </div>
                        <div @click="changeEditor(editor, 0)">
                            <div v-if="!editingHtml">
                                <editor-content :editor="editor"/>
                            </div>
                            <div v-else>
                                <prism-editor class="prism_editor"
                                              v-model="html"
                                              :code="html"
                                              language="html"
                                              :insertSpaces="false"
                                              line-numbers
                                              :highlight="highlighter"/>
                            </div>
                        </div>
                    </div>
                    <div :class="'col-'+(12-col_1)">
                        <div class="column-gap">{{12-col_1}} / 12</div>
                        <div @click="changeEditor(editor2, 1)">
                            <div v-if="!editingHtml">
                                <editor-content :editor="editor2"/>
                            </div>
                            <div v-else>
                                <prism-editor class="prism_editor"
                                              v-model="html2"
                                              :code="html2"
                                              language="html"
                                              :insertSpaces="false"
                                              line-numbers
                                              :highlight="highlighter"/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </EditorBlock>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
    .column-input {
        max-width: 50px;
        display: inline;
    }
    .column-gap {
        height: 50px;
    }

</style>

<script>

// Tip tap stuff
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble, Text } from 'tiptap'
import {
    OrderedList,
    BulletList,
    ListItem,
    Bold,
    Image,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Table,
    TableHeader,
    TableCell,
    TableRow,
    Heading,
    Placeholder,
} from 'tiptap-extensions'
import ImageExtension from "@/components/tiptap/extensions/Nodes/image_extension.js";
import ParagraphExtension from "@/components/tiptap/extensions/Nodes/paragraph_extension";
import TextColorExtension from "@/components/tiptap/extensions/Marks/textcolor_extension";
import TextHighlightExtension from "@/components/tiptap/extensions/Marks/texthighlight_extension";
import FontSizeExtension from "@/components/tiptap/extensions/Marks/fontsize_extension";

import ColorPicker from "@/components/tiptap/extensions/ColorPicker";
import FontSizePicker from "@/components/tiptap/extensions/FontSizePicker";

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/themes/prism.css';

import TipTapMenu from "@/components/tiptap/TipTapMenu";
import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";

export default {
    data: () => ({
        editor: null,
        editor2: null,
        col_1: 4,
        editingHtml: false,
        html: "",
        html2: "",
        selectedEditor: null,
        selectedIndex: 0,
    }),
    props: ['block'],
    components: {
        EditorBlock,
        TipTapMenu,
        EditorContent,
        PrismEditor,
    },
    methods: {
        highlighter(code) {
            return highlight(code, languages.html, 'html');
        },
        changeEditor(editor, index) {
            this.selectedEditor = editor;
            this.selectedIndex = index;
        },
        getExtensions() {
            return [
                new Placeholder(),
                new BulletList(),
                new OrderedList(),
                new ListItem(),
                new Bold(),
                // new Image(),
                new Italic(),
                new Link(),
                new Strike(),
                new Underline(),
                new History(),
                new Table({
                    resizable: true,
                }),
                new TableHeader(),
                new TableCell(),
                new TableRow(),
                new ImageExtension(),
                new ParagraphExtension(),
                new TextColorExtension(),
                new TextHighlightExtension(),
                new FontSizeExtension(),
            ];
        },
        handleUpdate(editorValue, columnIndex) {
            let html = null
            if (editorValue) {
                html = editorValue.getHTML()
            }

            if (html === '<p></p>') {
                html = ''
            }

            this.$emit('input', html)
            this.block.value[columnIndex] = html;
        },
        editHtml() {
            if (this.editingHtml) {
                this.editor.setContent(this.html);
                this.editor2.setContent(this.html2);
                this.block.value[0] = this.html;
                this.block.value[1] = this.html2;
                this.editingHtml = false;
                return;
            }

            this.editingHtml = true;
            this.html = this.editor.getHTML();
            this.html2 = this.editor2.getHTML();
        }
    },
    watch: {
        html(value) {
            this.blocks.value[0] = this.html;
        },
        html2(value) {
            this.blocks.value[1] = this.html2;
        },
        col_1(value) {
            this.blocks.value[2] = this.col_1;
        }
    },
    mounted () {
        // Create editor instances
        this.editor = new Editor({
            extensions: this.getExtensions(),
            content: this.block.value[0],
            onUpdate: (value) => this.handleUpdate(value, 0),
        });
        this.editor2 = new Editor({
            extensions: this.getExtensions(),
            content: this.block.value[1],
            onUpdate: (value) => this.handleUpdate(value, 1),
        });

        // Set selected editor to first one
        this.selectedEditor = this.editor;
        this.block.value[2] = this.col_1;
    }
}
</script>
